module.exports = __webpack_public_path__ + "static/biennale-semi-bold-e9a968b1c2253cb0d551048dae9c0c95.otf";